import React, { forwardRef, useState } from 'react';
import type { Merge } from 'types/utility';
import type { Props as InputProps } from './Input';
import Input from './Input';

interface OwnProps {
  options: Array<string>;
}

type Props = Merge<InputProps, OwnProps>;

let globalCounter = 0;

const InputWithAutocomplete: React.FC<Props> = forwardRef(({ options, ...inputProps }, ref) => {
  const counter = useState(() => globalCounter++);
  const listId = `autocomplete-input-list-${counter}`;
  return (
    <>
      <datalist id={listId}>
        {options.map(option => (
          <option key={option}>{option}</option>
        ))}
      </datalist>
      <Input type="text" list={listId} autoComplete="off" {...inputProps} ref={ref} />
    </>
  );
});

export default InputWithAutocomplete;
